import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3b436c46&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b436c46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/henri/Documents/Projects/circle-timer-server/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VFooter,VLayout})
